/* Exact-match search: quote each search term on submit so Shopify skips fuzzy padding.
   The search results template redirects back to an unquoted (fuzzy) query when exact finds nothing. */
(function () {
	function quoteQuery(q) {
		if (!q || q.indexOf('"') !== -1) return q; /* user's own quotes win */
		return q.trim().split(/\s+/).map(function (t) { return '"' + t + '"'; }).join(" ");
	}

	document.addEventListener("submit", function (event) {
		var form = event.target;
		if (!form || !form.getAttribute) return;
		var action = form.getAttribute("action") || "";
		/* only the full search form — not the predictive (/search/suggest) form */
		if (!/\/search\/?$/.test(action.split("?")[0])) return;
		var input = form.querySelector('input[name="q"]');
		if (input) input.value = quoteQuery(input.value);
	}, true);
})();
